<template>
  <div>
    <NavBar />
    <div class="container">
      <b-overlay :show="loading" opacity="0.99">
        <v-btn
          v-if="permissions.profile.write"
          class="v-primary mb-1"
          v-on:click="handleModalCreate"
        >
          <span class="fa fa-plus"></span> Novo
        </v-btn>
        <!-- Modal create profile -->
        <b-modal id="create" hide-footer>
          <template v-slot:modal-title>Novo perfil</template>
          <div class="d-block">
            <div class="container">
              <form v-on:submit="create" method="post">
                <div class="row">
                  <WarningRequiredFields />
                  <ErrorsMessages :errors="errors" />
                  <div class="col-md-12">
                    <LabelRequiredField label="Nome" />
                    <input type="text" v-model="name" class="form-control" />
                  </div>
                  <div class="col-md-12 text-right">
                    <v-btn
                      :disabled="loadingCreate"
                      type="submit"
                      class="v-success"
                    >
                      <span class="fa fa-check"></span>
                      {{ loadingCreate ? "Carregando" : "Salvar" }}
                    </v-btn>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </b-modal>
        <!-- /Modal create profile -->
        <v-card>
          <v-card-title>
            Perfis
            <v-spacer />
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Pesquisar"
              single-line
              hide-details
            />
          </v-card-title>
          <v-data-table
            dense
            :headers="headers"
            :items="profiles"
            :search="search"
            class="elevation-1"
            :footer-props="{
              'items-per-page-options': [25, 75, 100],
              'items-per-page-text': 'Mostrar',
            }"
            @click:row="handleClickRowTable"
          />
        </v-card>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import WarningRequiredFields from "../templates/components/WarningRequiredFields";
import LabelRequiredField from "../templates/components/LabelRequiredField";
import ErrorsMessages from "../templates/components/ErrorsMessages";
import NavBar from "../templates/NavBar";

import { formatDate } from "../functions/format";

import api from "../services/api";

import routes from "../routes";
import { adminData } from "../lib/functions";

export default {
  name: "Perfis",
  components: {
    NavBar,
    WarningRequiredFields,
    LabelRequiredField,
    ErrorsMessages,
  },
  data() {
    return {
      permissions: {},
      errors: [],
      search: "",
      headers: [
        { text: "Código", sortable: false, value: "id" },
        { text: "Nome", value: "name" },
        { align: "end", text: "", sortable: false, value: "edit" },
      ],
      name: "",
      value: "",
      profiles: [],
      loadingCreate: false,
      loading: true,
    };
  },
  created() {
    this.permissions = adminData().permissions;

    this.get();
  },
  methods: {
    formatDate,
    handleClickRowTable({ id }) {
      routes.push({ name: "profile", params: { id } });
    },
    async get(page = 1) {
      try {
        this.loading = true;

        const response = await api.get("/admin/profile/paginate", {
          params: { page },
        });

        const { profiles } = response.data;

        this.profiles = profiles;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async create(event) {
      event.preventDefault();
      this.loadingCreate = true;

      try {
        const { name } = this;
        let params = {
          name,
        };

        const response = await api.post("/admin/profile/create", params);
        const { error, errors } = response.data;
        if (!error) {
          this.$bvModal.hide("create");
          this.get();
          this.errors = [];
        } else {
          this.errors = errors;
        }
        this.loadingCreate = false;
      } catch (error) {
        console.log(error);
      }
    },
    handleModalCreate() {
      this.errors = [];
      this.name = "";
      this.$bvModal.show("create");
    },
  },
};
</script>